(() => {
  'use strict';
  const services = ['omra', 'omra-en-groupe', 'omra-sur-mesure', 'omra-sans-agence', 'omra-tout-compris', 'omra-ramadan'];
  const phoneValid = value => /^\+?[\d\s().-]+$/.test(value.trim()) && value.replace(/\D/g, '').length >= 7 && value.replace(/\D/g, '').length <= 15;
  if (typeof module !== 'undefined' && module.exports) { module.exports = { phoneValid }; return; }
  const init = root => {
    if (root.dataset.plannerReady) return;
    root.dataset.plannerReady = 'true';
    const dialog = root.closest('dialog');
    const legacy = dialog.querySelector('[data-project-wizard]');
    const form = root.querySelector('form');
    const copy = JSON.parse(root.querySelector('[data-planner-copy]').textContent);
    const steps = [...root.querySelectorAll('[data-planner-step]')];
    const styles = [...root.querySelectorAll('[data-planner-style]')];
    styles.forEach(button => { if (window.CTOFormUX.photo(button.querySelector('.cto-planner__art'),button.dataset.plannerStyle)) button.classList.add('cto-planner__choice--photo'); else button.classList.add('cto-planner__choice--plain'); });
    const periods = [...root.querySelectorAll('[data-planner-timing]')];
    const error = root.querySelector('[data-planner-error]');
    const service = root.querySelector('[data-planner-service]');
    const period = root.querySelector('[data-planner-period]');
    const people = root.querySelector('#PlannerPeople');
    let current = 0;
    let lastTracked = '';
    const styleButton = () => styles.find(button => button.dataset.plannerStyle === service?.value);
    const updateStyle = value => {
      service.value = value;
      root.dataset.ctoService = value || 'omra';
      const origin = root.querySelector('[data-planner-origin]');
      if (origin.value) origin.disabled = value === 'omra-sans-agence';
      styles.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.plannerStyle === value)));
    };
    const recap = () => {
      const target = root.querySelector('[data-planner-recap]');
      target.replaceChildren();
      const add = (label, index) => {
        if (!label) return;
        const button = document.createElement('button');
        button.type = 'button'; button.textContent = label;
        button.setAttribute('aria-label', `${copy.edit} : ${label}`);
        const icon = document.createElement('span'); icon.textContent = '✎'; icon.setAttribute('aria-hidden', 'true'); button.append(icon);
        button.addEventListener('click', () => show(index)); target.append(button);
      };
      add(styleButton()?.querySelector('strong').textContent, 0);
      add(period.value, 1);
      if (people.value) add(`${copy.people} : ${people.value}`, 1);
    };
    const track = () => {
      const key = `${root.dataset.ctoService}:${current}`;
      if (root.hidden || !dialog.open || key === lastTracked || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      window.CTOAnalytics?.capture('quote_step_viewed', { step: current + 1, service: root.dataset.ctoService });
      lastTracked = key;
    };
    const show = (index, focus = true) => {
      current = index;
      root.dataset.projectReady = 'true';
      root.dataset.projectStep = index === 2 ? '4' : String(index + 1);
      steps.forEach((step, i) => { step.hidden = i !== index; });
      root.querySelector('[data-planner-status]').textContent = copy.step.replace('__current__', index + 1).replace('__total__', steps.length);
      root.querySelector('[data-planner-progress]').value = index + 1;
      root.querySelector('[data-planner-back]').hidden = index === 0;
      error.hidden = true;
      if (index === 2) recap();
      if (focus) {
        steps[index].querySelector('legend').focus({ preventScroll: true });
        dialog.querySelector('.cto-popup__body').scrollTop = 0;
      }
      track();
    };
    const fail = (index, target, message = copy.error) => {
      show(index, false); error.textContent = message; error.hidden = false;
      target?.setAttribute('aria-invalid', 'true'); target?.focus();
    };
    const validChoices = () => {
      if (!styleButton()) { fail(0, styles[0]); return false; }
      if (!period.value) { fail(1, periods[0]); return false; }
      return true;
    };
    if (steps.length) {
      form.noValidate = true;
      const clearError = event => { event.target.removeAttribute('aria-invalid'); error.hidden = true; };
      form.addEventListener('input', clearError);
      form.addEventListener('change', clearError);
      root.querySelector('[data-planner-back]').addEventListener('click', () => show(current - 1));
      styles.forEach(button => button.addEventListener('click', () => {
        styles.forEach(item => item.removeAttribute('aria-invalid'));
        updateStyle(button.dataset.plannerStyle);
        show(1);
      }));
      periods.forEach(button => button.addEventListener('click', () => {
        periods.forEach(item => { item.removeAttribute('aria-invalid'); item.setAttribute('aria-pressed', String(item === button)); });
        period.value = button.querySelector('strong').textContent;
        show(2);
      }));
      form.addEventListener('submit', event => {
        if (current !== 2) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        if (!validChoices()) { event.preventDefault(); event.stopImmediatePropagation(); return; }
        const phone = root.querySelector('input[type=tel]');
        phone.setCustomValidity(phone.value && !phoneValid(phone.value) ? copy.phone_error : '');
        const name = root.querySelector('[name="contact[name]"]'); name.value = name.value.trim();
        const invalid = [...steps[2].querySelectorAll('input')].find(input => !input.checkValidity());
        if (invalid) {
          event.preventDefault(); event.stopImmediatePropagation();
          const details = invalid.closest('details'); if (details) details.open = true;
          fail(2, invalid, invalid.validationMessage); invalid.reportValidity(); return;
        }
        root.querySelector('[data-planner-body]').value = `${copy.style_title}\n${styleButton().querySelector('strong').textContent}\n\n${copy.timing_title}\n${period.value}${people.value ? `\n${copy.people} : ${people.value}` : ''}`;

      }, true);
      const params = new URLSearchParams(location.search);
      if (params.get('origin') === 'Marseille') {
        const origin = root.querySelector('[data-planner-origin]'); origin.value = 'Marseille'; origin.disabled = false;
      }
      if (/^2027-\d{2}-\d{2}$/.test(params.get('departure') || '')) period.value = params.get('departure');
      show(root.querySelector('[data-cto-inquiry-error]') ? 2 : 0, false);
    }
    dialog.addEventListener('cto:popup-open', event => {
      const requested = event.detail.service || legacy.dataset.ctoService || 'omra';
      const returnId = event.detail.returnForm || location.hash.slice(1);
      const legacyReturn = returnId === 'QuotePopupForm';
      const active = !legacyReturn && (returnId === 'OmraPlannerForm' || services.includes(requested));
      root.hidden = !active; legacy.hidden = !!active;
      dialog.classList.toggle('cto-popup--planner', !!active);
      if (!active) return;
      dialog.querySelector('#CTOQuotePopupTitle').textContent = copy.title;
      if (steps.length) {
        const contextual = requested === 'omra-tout-compris' ? 'omra-sur-mesure' : requested === 'omra-ramadan' ? 'omra-en-groupe' : requested;
        if (requested !== 'omra' && contextual !== service.value) { updateStyle(contextual); current = 0; }
        show(window.CTOFormReturn?.formId === form.id ? 2 : current, false);
      }
    });
    document.addEventListener('visitorConsentCollected', track);
    dialog.addEventListener('cto:popup-visible', track);
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || root.hidden) return;
      const focusable = [...dialog.querySelectorAll('button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), a[href], summary')].filter(node => !node.closest('[hidden]') && node.getClientRects().length);
      const first = focusable[0]; const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    window.addEventListener('pageshow', () => {
      if (!steps.length) return;
      root.querySelector('[type="submit"]').disabled = false; form.removeAttribute('aria-busy');
      root.querySelector('[data-planner-send-label]').textContent = form.dataset.humanMode === 'call' ? window.CTOHumanForms.copy.call_send : window.CTOHumanForms.copy.email_send;
    });
  };
  document.querySelectorAll('[data-omra-planner]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-omra-planner]').forEach(init));
})();
